import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-external-link',
  standalone: false,
  templateUrl: './external-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./external-link.component.scss'],
})
export class ExternalLinkComponent {
  @Input() url: string;

  constructor() {}
}
